import styled from "styled-components";

export const Container = styled.div(() => {
    return {
        height: "16px",
        backgroundColor: "transparent",
    };
});
